import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import CustomDateModal from '../../CustomModal/CustomDateModal';
import { useSelector } from 'react-redux';
import NoDataFound from '../../constants/NoDataFound';


const ChallanAgrMaster = (props) => {

    //----------- REDUCE TOOLKIT -------
    const vendorState = useSelector((state) => state.vendorState);
    const branchState = useSelector((state) => state.branchState);
    const { user } = useSelector((state) => state.authState);
      const sessionData = useSelector((state) => state.sessionState);

    const [challanTable, setChallanTable] = useState([]);
    const [searchKey, setSearchkey] = useState("");

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showDateModel, setShowDateModel] = useState(false);
    const [allDateSelected, setAllDateSelected] = useState(true);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination

    const location = useLocation();
    const navigate = useNavigate();

    // const getChallanData = async (flag, search) => {
    //     try {
    //         let config = {
    //             headers: {
    //                 'Content-Type': 'application/json', // Important for file upload//s
    //                 'accept': 'application/json'
    //             }
    //         };

    //         let queryParams = `flag=${flag}`;

    //         if (search) queryParams += `&searchKey=${encodeURIComponent(search?search:searchKey)}`;
    //         if (fromDate) queryParams += `&startDate=${encodeURIComponent(fromDate)}`;
    //         if (toDate) queryParams += `&endDate=${encodeURIComponent(toDate)}`;

    //         // const response = await apiService.get(`/api/IssueReceipt/allchallan?flag=${flag}`, config)
    //         const response = await apiService.get(`/api/IssueReceipt/allchallan?${queryParams}`, config); if (response.response && response.response.data.errors) {
    //             toast.success(response.response?.data?.errors);
    //         }

    //         if (response.status === true) {
    //             setChallanTable(response.issueReceiptMasterDetailData)
    //         }
    //         else {
    //             toast.success(response.message);
    //         }
    //     } catch (error) {
    //         console.log(error)
    //         toast.error(`SomeThing went wrong!!`);
    //     }
    // };.

    const getChallanData = async (flag, search, page = 1, limit = 10, venderMstId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            // Build query params conditionally
            let queryParams = `flag=${flag ? flag : props.irFlag}&pageNo=${page}&pageSize=${limit}`;
    sessionData.session_year && (queryParams += `&session=${encodeURIComponent(sessionData.session_year)}`);
         
            if (search) queryParams += `&searchKey=${encodeURIComponent(search ? search : searchKey)}`;
            if (startDate) queryParams += `&startDate=${encodeURIComponent(startDate)}`;
            if (endDate) queryParams += `&endDate=${encodeURIComponent(endDate)}`;
            // if (selectedVendorId) queryParams += `&venderMasterId=${encodeURIComponent(selectedVendorId)}`;
            // if (selectedBranchId) queryParams += `&branchMasterId=${encodeURIComponent(selectedBranchId)}`;
            const vendorIdToUse = venderMstId || selectedVendorId;
            if (vendorIdToUse) {
                queryParams += `&venderMasterId=${encodeURIComponent(vendorIdToUse)}`;
            }

            // ✅ Only include branchMasterId if venderMstId is NOT passed directly
            if (selectedBranchId && !venderMstId) {
                queryParams += `&branchMasterId=${encodeURIComponent(selectedBranchId)}`;
            }




            // const response = await apiService.get(`/api/IssueReceipt/allchallan?flag=${flag}`, config)
            const response = await apiService.get(`/api/IssueReceipt/allchallan?${queryParams}`, config);
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setChallanTable(response.issueReceiptMasterDetailData)
                setTotalPage(response.totalPages)

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    // useEffect(() => {
    //     getChallanData(props?.irFlag, "", 1, 10);
    // }, [!challanTable]);


    const onHandleSearchKey = (e) => {
        let search = e.target.value;
        setSearchkey(search);
        // getChallanData(props?.irFlag, search)
        getChallanData(props?.irFlag, search, 1, 10);

    }



    const onHandleChallan = () => {
        navigate("/add_challan_issue_agr")
    }

    const onHandleDeleteChallan = async (challanId) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/IssueReceipt/delete?challanId=${challanId}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getChallanData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    }

    const onHandleEditChallan = (challanId) => {
        let findArrayData = challanTable.find(e => e.id === challanId);
        navigate('/add_challan_issue_agr', { state: { challanId: findArrayData.id, partyId: findArrayData.pcode } });
    }

    const handleApply = () => {
        setShowDateModel(true);
    }


    const handlePageClick = (data) => {
        getChallanData(props?.irFlag, "", data.selected + 1, 10)
    };
    // =======================  VENDER & BRANCH =================

    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedBranchId, setSelectedBranchId] = useState("");

    // Handle vendor selection change
    const selectVendorFilter = (e) => {

        let value = e.target.value
        if (!value) {
            setSelectedVendorId(value);
            setSelectedBranchId("");
        } else {
            setSelectedVendorId(value);
            setSelectedBranchId("");
            getChallanData(props?.irFlag, "", 1, 10, value);
        }
    };


    // Handle branch selection change
    const selectbranchFilter = (e) => {
        setSelectedBranchId(e.target.value);
    };

    // useEffect(() => {
    //     getChallanData(props?.irFlag, "", 1, 10);
    // }, [selectedVendorId, selectedBranchId])

    useEffect(() => {

        if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
            getChallanData(props?.irFlag, "", 1, 10);
        } else if (user.user_profile == "superadmin") {
            getChallanData(props?.irFlag, "", 1, 10);
        }

        if (vendorState.vendors.length == 1) {
            setSelectedVendorId(vendorState.vendors[0].id);
        }

        if (branchState.branches.length == 1) {
            setSelectedBranchId(branchState.branches[0].id);
        }
    }, [selectedVendorId, selectedBranchId])

{/* Determine visibility */}
const showVendor = vendorState?.vendors.length === 0 || vendorState?.vendors.length > 1;
const showBranch = branchState?.branches?.length === 0 || branchState?.branches?.length > 1;

    return (
        <>
          <div className="d-flex justify-content-end mb-3">
                                    <Button color="primary" onClick={onHandleChallan} className="d-flex align-items-center">
                                        <i className="bi bi-plus-circle mr-2"></i> Add New 
                                    </Button>
                                </div>
 {/* Filters Section */}
               {/* Render card only if any filter is visible */}
{(showVendor || showBranch) && (
  <Card className="card-box bg-white p-3 mb-4">

    <Row className={showVendor && showBranch ? "" : "justify-content-center"}>
      {/* Vendor Filter */}
      {showVendor && (
        <Col sm={6} md={4}>
          <FormGroup>
            <label className="fw-bold mb-1">Choose Vendor</label>
            <Input
              type="select"
              className="custom-select"
              name="selectedVendorId"
              value={selectedVendorId}
              onChange={selectVendorFilter}
            >
              <option value="">-- Select Vendor --</option>
              {vendorState?.vendors.map((data) => (
                <option key={data.id} value={data.id}>
                  {data.vender_name}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      )}

      {/* Branch Filter */}
      {showBranch && (
        <Col sm={6} md={4}>
          <FormGroup>
            <label className="fw-bold mb-1">Choose Branch</label>
            <Input
              type="select"
              className="custom-select"
              name="selectedBranchId"
              value={selectedBranchId}
              onChange={selectbranchFilter}
              disabled={!selectedVendorId}
            >
              <option value="">-- Select Branch --</option>
              {branchState?.branches
                ?.filter((data) =>
                  selectedVendorId
                    ? String(data.vender_master_id) === String(selectedVendorId)
                    : true
                )
                .map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.branch_name}
                  </option>
                ))}
            </Input>
          </FormGroup>
        </Col>
      )}
    </Row>

  </Card>
)}
                <Card className="card-box bg-white p-2 mb-4">
     <CardTitle 
  tag="h6" 
  className="border-bottom shadow-sm mb-0 p-3 bg-white sticky-top"
>
  {/* First Row: Title + Filter Button */}
  <Row className="align-items-center mb-3">
    
    {/* Title (left) */}
    <Col xs={8} className="d-flex align-items-center">
      <i className="bi bi-card-checklist text-primary mr-2"></i>
      <span className="fw-semibold text-dark">
        Issue Challan (FH)
      </span>
    </Col>

    {/* Filter Button (right) */}
    <Col xs={4} className="text-right">
      <Button 
      size="sm"
        color="primary" 
        onClick={handleApply}
        className="shadow-sm btn-sm"
      >
        <i className="bi bi-funnel-fill mr-1"></i>
        Filter
      </Button>
    </Col>

  </Row>

  {/* Second Row: Search Bar (full width) */}
  <Row>
    <Col xs={12}>
      <Input
      className='form-control-sm'
        id="search"
        name="search"
        placeholder="Search..."
        type="text"
        onChange={(e) => onHandleSearchKey(e)}
      />
    </Col>
  </Row>
</CardTitle>
                                                              

                    <CardBody className="">
                        <Table hover striped responsive>
                            <thead className='bg-primary text-white'>
                                <tr>
                                    <th></th>
                                    <th>Bill No.</th>
                                    {(user.user_profile == "superadmin" || branchState.length) && <th>Branch/Vendor Name</th>}

                                    {/* <th>id</th> */}
                                    <th>Bill Date</th>
                                    <th>Party  Name</th>
                                    <th>Qty</th>
                                    <th>Amt</th>

                                    {/* <th>Permit No</th>
                                    <th>Vehicle No</th> */}
                                    {/* <th>Edit</th> */}
                                    {/* <th>Delete</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                  {challanTable.length > 0 ? challanTable.map((item, index) => (
                                    <tr key={index}>
                                        <th scope='row' >

                                                        <i data-toggle="tooltip" title="Click to Update Party" data-placement="bottom" className="bi bi-pencil mr-1 text-primary" style={{ cursor: "pointer" }} onClick={() => onHandleEditChallan(item.id)} />
                                                    </th>

                                        <th scope='row'>{item.manual_billno}</th>
                                        {(user.user_profile == "superadmin" || branchState.length) && <td>{item.branch_name} ***** <br></br>{item.vender_name}</td>}


                                        <td>{item.bill_date?.split('T')[0]}</td>
                                        <td>{item.pname}{" "}{(item.agr_code_old)}</td>
                                        <td>{item.tot_qty}</td>

                                        <td>₹{item.final_amount}</td>

                                        {/* <td>{item?.permit_no}</td>
                                        <td>{item?.vehicleno}</td> */}
                                        {/* <td>
                                            <Button color="warning" size="bg" onClick={() => onHandleEditChallan(item.id)}>
                                                <i className="fas fa-edit"></i>
                                            </Button>
                                        </td> */}
                                        {/* <td>
                                            <Button color="danger" size="bg" onClick={() => onHandleDeleteChallan(item.id)}>
                                                Delete
                                            </Button>
                                        </td> */}
                                    </tr>
                                )) : <NoDataFound colSpan={6} />}
                            </tbody>
                        </Table>
                    </CardBody>

                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={totalPage} // still 4000
                        marginPagesDisplayed={1} // 1 page at start & end
                        pageRangeDisplayed={2}  // visible range around selected page
                        onPageChange={handlePageClick}
                        
  containerClassName={'pagination d-flex justify-content-center'} // ✅ center
                        activeClassName={'active'}

                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        nextClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextLinkClassName={'page-link'}
                        breakClassName={'page-item'}
                        breakLinkClassName={'page-link'}
                    />
                </Card>
        

            <CustomDateModal

                filterFlag="sale_report"

                showDateModel={showDateModel}
                setShowDateModel={setShowDateModel}

                allDateSelected={allDateSelected}
                setAllDateSelected={setAllDateSelected}

                startDate={startDate}
                setStartDate={setStartDate}

                endDate={endDate}
                setEndDate={setEndDate}

                // handleCloseModel={handleCloseModel}
                // handleFilterDate={handleFilterDate}
                getChallanData={getChallanData}
            />


        </>
    )
}

export default ChallanAgrMaster